import { FC } from 'react';
import { AmplienceMegaNavProps } from '../header-nav/components/mega-nav';
import AmplienceMegaNavMobile from '../header-nav/components/mega-nav/mega-nav-mobile';
import AmplienceNavColumn from '../header-nav/components/nav-column';

export interface FooterMegaNavProps {
  megaNav: AmplienceMegaNavProps;
}
const FooterMegaNav: FC<FooterMegaNavProps> = ({ megaNav }) => {
  return (
    <>
      {megaNav && megaNav.navColumns?.length > 0 && (
        <>
          <div
            className="mb-12 mt-9 hidden h-auto w-full px-[15px] lg:mx-auto lg:block lg:max-w-[var(--page-max-width)] lg:px-4"
            data-testid="footer-desktop-navigation"
          >
            <section className="mx-auto grid max-w-desktop">
              <section className="flex justify-between">
                {megaNav?.navColumns.map((navColumn) => (
                  <AmplienceNavColumn key={`nav-column-${navColumn?.mainTitle}`} {...navColumn} isFooterColumn={true} />
                ))}
              </section>
            </section>
          </div>

          <div data-testid="footer-mobile-navigation" className="block lg:hidden">
            <AmplienceMegaNavMobile
              title={megaNav.title}
              link={megaNav.link}
              navColumns={megaNav.navColumns}
              includeHeader={false}
              navColumnClassName="!border-0"
              footerMegaNav={true}
            />
          </div>
        </>
      )}
    </>
  );
};

export default FooterMegaNav;
